import React from "react"

const ItemValue: React.FC<{ label: string; value: string | number; unit: string }> = ({ label, value, unit }) => {
  return (
    <div className="itemValue">
      <div className="itemValue-label">{label}:</div>
      <div className="itemValue-value">
        <span>{value}</span>
        <span>{unit}</span>
      </div>
    </div>
  )
}

export default ItemValue
